export default {
  loadFilteredRows: (dispatch, rows) => {
    dispatch({ type: 'LOAD_FILTERED_ROWS', rows });
  },

  selectRow: (dispatch, row, value) => {
    dispatch({ type: 'SELECT_ROW', rowId: row.id, checked: value });
  },

  disableRow: (dispatch, row) => {
    dispatch({ type: 'DISABLE_ROW', rowId: row.id });
  },

  allRowsToggle: (dispatch, value) => {
    if (value) {
      dispatch({ type: 'SELECT_ALL_ROWS' });
    } else {
      dispatch({ type: 'DESELECT_ALL_ROWS' });
    }
  },

  search: (dispatch, value) => {
    dispatch({ type: 'SEARCH', value });
  },

  searchByText: (dispatch, name, value) => {
    dispatch({ type: 'FILTER', name, value });
  },

  searchBySelect: (dispatch, name, selectedOptions) => {
    let value = null;

    if (selectedOptions) {
      value = [selectedOptions].flat().map((option) => option.value);
    }

    dispatch({ type: 'FILTER', name, value });
  },

  showOnlySelectedRows: (dispatch, value) => {
    dispatch({ type: 'SHOW_ONLY_SELECTED_ROWS', value });
  },

  clearFilters: (dispatch) => {
    dispatch({ type: 'CLEAR_FILTERS' });
  },
};
